import { useState } from 'react';
import classNames from 'classnames';
import {
  uniqueId,
} from 'lodash';
import {
  Field2 as Field,
  FieldGroupContainer,
  VibeIcon,
  viTrash,
  color,
} from 'vibeguide';
import './Domains.scss';

function Domains({
  className = '',
  domains = [],
  disableInput = false,
  onUpdate = () => {},
}) {
  // keep stable row ids so editing/removing doesn't lose input focus
  const [rows, setRows] = useState(() => {
    const initial = domains.length > 0
      ? domains
      : [''];

    return initial.map(value => ({
      _id: uniqueId('domain-'),
      value,
    }));
  });

  /**
   * Send the latest list of domains up to the parent
   */
  const update = (newRows) => {
    setRows(newRows);

    onUpdate({
      domains: newRows.map(row => row.value),
    });
  };

  /**
   * When a domain value is changed
   */
  const onChangeDomain = (rowId, value) => {
    update(rows.map(row => (row._id === rowId
      ? { ...row, value }
      : row)));
  };

  /**
   * Add a new empty domain row
   */
  const onAddDomain = () => {
    update([
      ...rows,
      {
        _id: uniqueId('domain-'),
        value: '',
      },
    ]);
  };

  /**
   * Remove a domain row (always keep at least one row visible)
   */
  const onRemoveDomain = (rowId) => {
    const newRows = rows.filter(row => row._id !== rowId);

    update(newRows.length > 0
      ? newRows
      : [{ _id: uniqueId('domain-'), value: '' }]);
  };

  return (
    <FieldGroupContainer
      className={classNames('Domains', className)}
      allowAddRow={!disableInput}
      addRowLabel="Add Domain"
      onAddRow={onAddDomain}
    >
      {rows.map((row) => (
        <div className="domain-row" key={row._id}>
          <div className="domain-input">
            <Field
              type="text"
              label="Domain"
              name={row._id}
              placeholder="example.com"
              value={row.value}
              disabled={disableInput}
              testId={`identity-provider-domain-input-${row._id}`}
              onChange={(e) => onChangeDomain(row._id, e.target.value)}
              required
            />
          </div>

          {!disableInput && (
            <VibeIcon
              className="domain-remove"
              icon={viTrash}
              color={color.error}
              hoverColor={color.error}
              size={20}
              tooltip="Remove Domain"
              onClick={() => onRemoveDomain(row._id)}
            />
          )}
        </div>
      ))}
    </FieldGroupContainer>
  );
}

export default Domains;
